/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetSkillContentRequest = {
  skillId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetSkillContentRequest$inboundSchema: z.ZodType<
  GetSkillContentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetSkillContentRequest$Outbound = {
  skill_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetSkillContentRequest$outboundSchema: z.ZodType<
  GetSkillContentRequest$Outbound,
  z.ZodTypeDef,
  GetSkillContentRequest
> = z.object({
  skillId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getSkillContentRequestToJSON(
  getSkillContentRequest: GetSkillContentRequest,
): string {
  return JSON.stringify(
    GetSkillContentRequest$outboundSchema.parse(getSkillContentRequest),
  );
}
export function getSkillContentRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetSkillContentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSkillContentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSkillContentRequest' from JSON`,
  );
}
